import React from 'react';
import ApplicationForm from '../components/ApplicationForm';
import CourseApplicationForm from '../components/CourseApplicationForm';
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';

const BTechElectricalEngineering = () => {
  const [showApplicationModal, setShowApplicationModal] = React.useState(false);

  return (
    <>
      {/* Page Title Banner */}
      <div className="breadcrumbbg page-title aos-init aos-animate" data-aos="fade">
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <h1 className="">B.Tech In Electrical Engineering</h1>
              <p className="fs-5 text-danger"><strong>Lateral Entry Program </strong></p>
              <p>Advance your career with our 3-year undergraduate program, designed for diploma holders and working professionals who need flexible learning schedules</p>
            </div>
          </div>
        </div>
      </div>

      {/* Course Overview Section */}
      <section id="overview" className="overview section">
        <div className="container" data-aos="fade-up" data-aos-delay="200">
          <div className="row">
            <div className="col-lg-8">
              <div className="border rounded overflow-hidden">
                <h2 className="fw-bold bg-primary bg-opacity-10 textprimary p-2 px-lg-3">Course Overview</h2>
                <div className="p-2 p-lg-3">
                  <p>The B.Tech in Electrical Engineering at Mewar University is a four-year undergraduate program (three years for lateral entry diploma holders) that focuses on building a strong foundation in the principles of electrical systems, power generation, transmission, and modern applications of electrical technology. The curriculum combines theoretical learning with extensive laboratory practice to help students master areas such as circuit theory, electrical machines, power systems, control systems, renewable energy technologies, and electrical instrumentation. With the increasing demand for energy efficiency and sustainable solutions, the program also introduces students to emerging fields like smart grids, automation, and green energy systems.</p>
                  
                  <p className="fs-5"><strong>Key Highlights</strong></p>
                  <ul className="list-group list-unstyled mb-2">
                    <li className="mb-2"><i className="bi bi-check-circle-fill text-danger mx-1"></i> <strong>Duration:</strong> Lateral Entry: 3 Years (6 Semesters)</li>
                    <li className="mb-2"><i className="bi bi-check-circle-fill text-danger mx-1"></i><strong>Eligibility:</strong> 10+2 with Physics, Chemistry, and Mathematics (PCM) / Diploma in Electrical or related field</li>
                    <li className="mb-2"><i className="bi bi-check-circle-fill text-danger mx-1"></i><strong>Comprehensive Curriculum</strong> Industry-Oriented Training with internships, workshops, and industrial visits</li>
                    <li className="mb-2"><i className="bi bi-check-circle-fill text-danger mx-1"></i> Strong Placement Support with opportunities in Power, Energy, IT, Manufacturing, and Government sectors</li>
                    <li className="mb-2"><i className="bi bi-check-circle-fill text-danger mx-1"></i> Focus on Emerging Technologies such as Smart Grids, Green Energy, and Industrial Automation</li>
                  </ul>
                  
                  <p>Graduates of this program can build careers as Electrical Engineers, Power System Engineers, Control System Engineers, or Design Engineers in organisations like BHEL, NTPC, Power Grid Corporation, and other leading electrical companies. They also have the option to pursue higher studies such as M.Tech or MBA.</p>
                  
                  <p>Conducted in a blended mode, the program delivers theory both online and offline, while practical and laboratory sessions are held on campus—providing the perfect balance of flexibility, quality, and career growth.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <CourseApplicationForm 
                courseName="B.Tech Electrical Engineering"
                courseValue="B-Tech-Electrical-Engineering"
                onApplyClick={() => setShowApplicationModal(true)}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Program Highlights Section */}
      <section id="programht" className="programht section blue-bg">
        <div className="container section-title" data-aos="fade-up" data-aos-delay="200">
          <p><span>Program </span> <span className="description-title">Highlights</span></p>
        </div>
        <div className="container" data-aos="fade-in" data-aos-delay="200">
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-lightning"></i>
                  </div>
                  <h5 className="fw-bold w-75">A Program for Specialized electrical Engneering</h5>
                </div>
                The B.Tech in Electrical Engineering at Mewar University is a specialized program that blends fundamental concepts with modern technologies. It prepares students with practical skills, industry exposure, and innovation-driven learning to build successful careers in the power and energy sector.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-hourglass-top"></i>
                  </div>
                  <h5 className="fw-bold w-75">Adaptable for Working Professionals</h5>
                </div>
                Designed with working professionals in mind, the program offers adaptable schedules that allow learners to upskill without interrupting their jobs.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-bookmark-star-fill"></i>
                  </div>
                  <h5 className="fw-bold w-75">Approved and Recognized by UGC/AICTE</h5>
                </div>
                The UGC and AICTE have recognized the Mewar University's B.Tech Lateral Entry programs, guaranteeing national recognition and eligibility for competitive tests like GATE and other government exams.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-person-rolodex"></i>
                  </div>
                  <h5 className="fw-bold w-75">Comprehensive Career Advancement</h5>
                </div>
                MEWAR University offers comprehensive professional development that goes beyond conventional teaching techniques. Through frequent industry expert guest lectures, live projects, and industry visits, the institution makes sure that students get both technical know-how and firsthand experience with real-world business situations.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-pc-display-horizontal"></i>
                  </div>
                  <h5 className="fw-bold w-75">Flexible Class Schedules & Round-the-Clock Access</h5>
                </div>
                Classes are offered in flexible time shifts on weekends, holidays, and weekdays (in the evening, after work hours). Once lessons are over, the Learning Management System (LMS) makes recorded lectures available around-the-clock.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-award"></i>
                  </div>
                  <h5 className="fw-bold w-75">Higher Levels of Experience Based Learning</h5>
                </div>
                A variety of experiential learning components are used in the program's experiments, including virtual labs, remote labs, and simulations. These components include industry-leading software tools, programming languages, and simulation software to create an on-campus experience.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-journal-medical"></i>
                  </div>
                  <h5 className="fw-bold w-75">All-inclusive Assessment Framework</h5>
                </div>
                Every semester, there are midterm and final exams for every course, which are often scheduled for the weekends. According to the semester's course schedule, online tests and assignments are also given.
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="h-100 p-3 p-lg-4 rounded-4 bg-white shadow-sm">
                <div className="d-flex gap-2 align-items-center mb-4 textprimary">
                  <div className="ph-iconbox bg-primary bg-opacity-10 shadow-sm">
                    <i className="bi bi-bullseye"></i>
                  </div>
                  <h5 className="fw-bold w-75">Various Professional Paths</h5>
                </div>
                Electrical Engineer, Power System Engineer, Control System Engineer, Design Engineer, and other positions are among the career options open to graduates of the B.Tech Lateral Entry Electrical Engineering program. Additionally, they are able to apply for government positions.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Explore Course Section */}
      <section id="explore-crs" className="explore-crs section bg-light">
        <div className="container section-title" data-aos="fade-up">
          <p><span>Explore </span> <span className="description-title"> Our Course</span></p>
        </div>
        <div className="container" data-aos="fade-up" data-aos-delay="200">
          <div className="row">
            <div className="col-md-12">
              <ul className="nav nav-tabs d-flex aos-init aos-animate" data-aos="fade-up" data-aos-delay="100" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link show active" href="#pills-eligibility" data-bs-toggle="tab" data-bs-target="#pills-eligibility" aria-selected="true" role="tab">
                    <h4>Eligibility Criteria</h4>
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#pills-pro-duration" data-bs-toggle="tab" data-bs-target="#pills-pro-duration" aria-selected="false" role="tab" tabIndex="-1">
                    <h4>Program Duration</h4>
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" href="#pills-fee-structure" data-bs-toggle="tab" data-bs-target="#pills-fee-structure" aria-selected="false" role="tab" tabIndex="-1">
                    <h4>Fee Structure</h4>
                  </a>
                </li>
              </ul>

              <div className="tab-content bg-white border rounded-3 p-3 p-lg-4 shadow-sm" id="pills-tabContent">
                <div className="tab-pane fade active show" id="pills-eligibility" role="tabpanel" aria-labelledby="pills-eligibility-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Eligibility Criteria
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <div className="qualification">
                    <h6 className="fw-600 mb-3">Qualification</h6>
                    <ol>
                      <li className="mb-2">To be eligible to apply, the candidate must have completed a 3-year polytechnic diploma in the relevant subject.</li>
                      <li className="mb-2">Candidate must have at least 1 year of work experience in any relevant job in registered companies, industries, institutions, educational or government organizations.</li>
                      <li className="mb-2">Professionals with experience in finding full potential in key sectors.</li>
                    </ol>
                  </div>
                  <div className="age-criteria">
                    <h6 className="fw-600 mb-3">Age Criteria</h6>
                    <ol>
                      <li className="mb-2">There is no age restriction for those who want to pursue this course.</li>
                      <li className="mb-2">People who want to advance their career by understanding the technical and basic principles well should apply for this course.</li>
                    </ol>
                  </div>
                </div>

                <div className="tab-pane fade" id="pills-pro-duration" role="tabpanel" aria-labelledby="pills-pro-duration-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Program Duration
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <ol>
                    <li className="mb-2">The program lasts a total of 3 years and is divided into 6 academic semester terms in lateral entry mode.</li>
                    <li className="mb-2">The final semester is for Project Work, VIVA, and Industrial Training.</li>
                    <li className="mb-2">The course includes theoretical lectures and virtual laboratories where the experiment is conducted remotely using simulations.</li>
                  </ol>
                </div>

                <div className="tab-pane fade" id="pills-fee-structure" role="tabpanel" aria-labelledby="pills-fee-structure-tab" tabIndex="0">
                  <h4 className="fw-600 textprimary mb-3 mb-lg-4">
                    Fee Structure
                    <div className="borderbottom-gradient"></div>
                  </h4>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Course Fee (Per Semester) - ₹ 40,000</h6>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Exam Fee (Per Semester) - ₹ 2500</h6>
                  <h6 className="bg-warning bg-opacity-25 p-2 rounded shadow-sm mb-3" style={{width: 'max-content'}}>Registration Fee (One Time) - ₹ 5000</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Programs Section */}
      <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

export default BTechElectricalEngineering;
